/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
type DeviceKind = 'audioinput' | 'audiooutput' | 'videoinput';

/**
 * Get the list of available media devices of the given kind.
 */
function filterDevicesByKind(deviceInfos: MediaDeviceInfo[], kind: DeviceKind): MediaDeviceInfo[] {
  return deviceInfos.filter((deviceInfo) => deviceInfo.kind === kind);
}

/**
 * Ensure that media permissions are obtained.
 */
async function ensureMediaPermissions(): Promise<void> {
  const devices = await navigator?.mediaDevices?.enumerateDevices();

  const shouldAskForMediaPermissions = devices.every(
    (device) => !(device.deviceId && device.label)
  );

  if (!shouldAskForMediaPermissions) {
    return;
  }

  const mediaStream = await navigator?.mediaDevices?.getUserMedia({ audio: true, video: true });

  mediaStream.getTracks().forEach((track) => {
    track.stop();
  });
}

/**
 * Get the list of available media devices.
 */
export async function getDeviceSelectionOptions() {
  // before calling enumerateDevices, get media permissions (.getUserMedia)
  // w/o media permissions, browsers do not return device Ids and/or labels.

  await ensureMediaPermissions();
  const deviceInfos = await navigator?.mediaDevices?.enumerateDevices();

  const kinds = ['audioinput', 'audiooutput', 'videoinput'] as DeviceKind[];

  return kinds.reduce<Record<string, MediaDeviceInfo[]>>((deviceSelectionOptions, kind) => {
    deviceSelectionOptions[kind] = filterDevicesByKind(deviceInfos, kind);

    return deviceSelectionOptions;
  }, {});
}
